import { Component, inject } from '@angular/core';
import { EAppNotificationType } from '@enums';
import { AppConfigService, AuthService } from '../../services';

@Component({
  selector: 'aup-error-page',
  templateUrl: './error-page.component.html',
  standalone: false,
})
export class ErrorPageComponent {
  EAppNotificationType = EAppNotificationType;

  public authService = inject(AuthService);
  private appConfigService = inject(AppConfigService);

  logoPath = this.appConfigService.getCountryConfig()?.logoPath;
  pageTitle = this.appConfigService.getCountryConfig()?.pageTitle;
}
